{
	"translatePaymentMethod": {
		"app": "Aplicativo",
		"cash": "Dinheiro",
		"creditCard": "Crédito",
		"debitCard": "Débito",
		"zigPosCredit": "Zig pós crédito",
		"zigPosDebit": "Zig pós débito",
		"voucher": "Voucher",
		"dashboard": "Dashboard",
		"anticipated": "Antecipado",
		"postEvent": "Após o evento",
		"rappi": "Rappi",
		"appPrePayment": "Pagamento via app",
		"pix": "Pix",
		"bonus": "Bônus",
		"zigPosCreditInInstallments": "Parcelamento",
		"integratedFoodVoucher": "Vale-refeição"
	},
	"translateEventStatus": {
		"created": "Fechado",
		"finished": "Fechado",
		"running": "Aberto",
		"canceled": "Cancelado"
	}
}
